<div class="kt-section">
	<div class="row kt-padding-20">
		<div class="col-md-2"></div>
		<div class="col-md-8 kt-align-center">
			<i class="fa fa-exclamation-triangle kt-font-danger" style="font-size:70px"></i>
			<h1 class="kt-font-danger">Accès interdit !!</h1>
			<h4 class="kt-font-bold">Vous n'avez pas le droit d'accès à la page demandée</h4>
			<p class="kt-font-bold">Si vous pensez qu'il s'agit d'une erreur, veuillez contacter votre administrateur.</p>
			<button type="button" class="btn btn-danger" (click)="retour()"><i class="flaticon-reply"></i>Retour</button>
		</div>
		<div class="col-md-2"></div>
	</div>
</div>
